export * from './cupom-desconto-relatorios.component';